<template>
	<div>
		<div class="header row" style="margin-bottom: 20px;">
			<a class="logo_data">
				<img src="https://img.hsnms.com/20220415/1649990007.png"></a>
		</div>

		<el-dialog title="我要买单" :visible.sync="dialogToAdd" width="90%">
			<el-form :model="itemForm" style="margin-top: -20px; text-align: left;">
				<el-form-item label="请输入实际消费金额" label-position="left" style="text-align: left;">
					<el-input @change="edit_it" type="number" style="font-size: 30px;" v-model="itemForm.name">
					</el-input>
				</el-form-item>
				<div style="text-align:center;">
					<el-button style="width: 100%; height: 50px; font-size: 18px;" @click="er" type="primary">生成核验码
					</el-button>
				</div>
			</el-form>
			<div style="margin-top: 20px; text-align: center;">
				<div class="er_img" id="qrcode" style="text-align: center;"></div>
			</div>
		</el-dialog>

		<el-dialog :title="im.title" :visible.sync="dialogToSEl" width="90%">
			<div>
				<div class="col-12">
					<h4 style="margin-top: 20px; margin-bottom: 20px;">{{im.title}}</h4>
					<h5>优惠：{{im.price_b}} 折</h5>
					<h5 style="margin-top: 20px; margin-bottom: 20px;"><i class="el-icon-phone"></i>
						{{im.imgages_sma_a}}
					</h5>
					<h5><i class="el-icon-location"></i> {{im.describe}}</h5>
				</div>
			</div>
		</el-dialog>


		<div class="bj_img_h m-slider" style="margin-top: -70px;">

			<div class="span12 text-left" @click="mai">
				<div style="background-image:url('https://img.hsnms.com/20220415/1649997243.jpeg'); background-size: 100% auto; "
					class="jumbotron jumbotron_aa">
					<h3 style="color: #fff; margin-top:0px">我要买单</h3>
					<h5>我要买单，输入实际金额</h5>
				</div>
			</div>

			<div style="margin-top: 20px; margin-bottom: 20px;">
				<h4 class="h_hei">商户联盟</h4>
				<div class="span12" style="margin-top: 25px;margin-bottom: 5px;"
					v-for="(item, index) in data_list_a.data">
					<!--t_10-->
					<div class="row" @click="models_sel(item)">
						<div class="col-4" style="padding-right:1px;">
							<div style="position:relative;width:100%;">
								<img style="width: 100%; border-radius:3%;" :src=item.imgages_max />
								<div style="position:absolute;left:0;top:0;">
									<div class="zhibo" style="padding-left: 5px; padding-right: 5px;">{{item.price_b}} 折
									</div>
								</div>
							</div>
						</div>
						<div class="col-8">
							<h4>{{item.classify_name}}</h4>
							<h5 style="margin-top: 20px;">
								<el-tag>{{item.label}}</el-tag>
							</h5>
							<h4><i class="el-icon-phone"></i>{{item.connect}}</h4>
							<h5 style="margin-top: 20px;">{{item.address}} </h5>
						</div>
					</div>
					<hr />
				</div>

				<el-button class="bin_tijiao_data" type="primary" v-if="data_list_a.v" @click="list_a">
					更多内容
				</el-button>

			</div>

		</div>
		<div style="height: 20px;"></div>
	</div>
</template>

<script>
	import QRCode from 'qrcodejs2'
	export default {
		data() {
			return {
				user_info: [],
				im: {
					title: "",
					price_b: "",
					describe: "",
					imgages_sma_a: "",
				},
				dialogToSEl: false,
				dialogToAdd: false,
				itemForm: {
					name: '',
					tel: '',
				},
				data_list_a: {
					data: [],
					page: 1,
					v: false,
				},
				tabPosition: 'top',
				usable: '1',
				tabs: [{
					name: '1',
					label: ''
				}]
			}
		},
		mounted() {
			this.list_a()
			this.Users_jurisdiction()
		},
		methods: {
			//查询用户
			models_sel(itme) {
				// this.dialogToSEl=true;
				// this.im.title=itme.title;
				// this.im.price_b=itme.price_b;
				// this.im.describe=itme.describe;
				// this.im.imgages_sma_a=itme.imgages_sma_a;
				this.$router.push({
					path: 'gfhx_show',
					query: {
						id: itme.id
					}
				});
			},
			route1: function(myurl) {
				window.open(myurl, "_blank");
			},
			list_a() {
				var datas = this.data_list_a;
				this.$api.getAPI("data/product/?type_id=2022040010&page=" + datas.page, {
					key_id: this.$route.query.id,
				}).then(res => {
					var lists = res.data.data.data[0].models;
					if (lists.length == 10) {
						datas.v = true;
						this.data_list_a.page = datas.page + 1;
					} else {
						this.data_list_a.v = false;
					}
					for (let i = 0; i < lists.length; i++) {
						this.data_list_a.data.push(lists[i])
					}
				})
			},
			handleClick(tab) {
				console.log(tab)
			},
			mai() {
				// if(this.user_info==null){
				// 	this.$Message.error("请注册会员，或者重新登陆系统！")
				// 	return
				// }
				this.dialogToAdd = true;
			},
			edit_it() {
				document.getElementById('qrcode').innerHTML = "";
				this.er()
			},
			er() {
				document.getElementById('qrcode').innerHTML = "";
				new QRCode(document.getElementById('qrcode'), {
					text: "https://www.hsnms.com/data/jjgh/zlb/#/web/jjgh/hy?id=" + this.itemForm.name, //要生成二维码的网址
					width: 256, //图像宽度
					height: 256, //图像高度
					colorDark: '#000000', //前景色
					colorLight: '#ffffff', //背景色
					margin: 0, //外边距
					correctLevel: QRCode.CorrectLevel
						.L //容错级别。属性值有：QRCode.CorrectLevel.L、QRCode.CorrectLevel.M、QRCode.CorrectLevel.Q、QRCode.CorrectLevel.H
				})
			},
			Users_jurisdiction() {
				//获取oepnid
				//var openid = this.$route.query.openid
				var openid="8afac2ed6026a8ae01604d88a3f06b14"
				this.user_info = this.$api.getUserInfo_jurisdiction(openid);
				if (this.user_info == null) {
					//this.$Message.error("请从新进入系统！")
					return false
				}
				return true
			}
		}
	}
</script>

<style>
	.header {
		height: 160px;
		color: #fff;
		background: url("http://www.baiduhrb.com/fjh/images/user_bg.png");
		background-size: 100% 100%;
	}

	.header .logo_data {
		display: block;
		float: left;
		margin-left: .8rem;
		margin-top: -25px;
	}

	.header .logo_data img {
		position: relative;
		overflow-x: hidden;
		width: 45%;
		height: auto;
		top: 0px;
	}

	.bin_tijiao_data {
		height: 50px;
		width: 100%;
		font-size: 16px;
		opacity: 0.6;
	}

	.m-slider {
		overflow-x: hidden;
		position: relative;
		border-radius: .45em;
	}

	.zhibo {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.loupan {
		opacity: 0.6;
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.jiage {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.h_hei {
		border-left: 5px solid #c5114f;
		padding-left: 5px;
	}

	.container-fluid {
		margin-top: 0px !important;
		max-width: 1200px;
	}

	.el-tabs__item {
		font-size: 16px !important;


	}

	.el-tabs__item is-top is-active {
		width: 50% !important;
	}

	.er_img img {
		text-align: center;
		width: 100%;
	}

	.el-form-item__label {
		text-align: left !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/jjgh/gfhx.vue